module.exports = __webpack_public_path__ + "static/media/AHW_03.95833021.jpg";